import React, {Component} from 'react'
import CTA from "./CTA";

class Lessons extends Component {
    render() {
        const descColor = "#6C63FF";
        const headingColor = "gray";

        return (
            <div id="lessonsIndex">
                <h1><i className="fas fa-chalkboard-teacher" /> Lessons</h1>
                <p style={{color: '#5a5a5a'}}>We offer three types of lessons</p>
                <br/><br/>
                <div id="heroIllustrations">
                    <div>
                        <div className="card-hover hero-feature">
                            <h3 style={{color: headingColor}}>Individual</h3>
                            <h1>We come to your preferred place</h1>
                            <p style={{color: descColor}}>Our rates depend on your location</p>
                        </div>
                    </div>
                    <div>
                        <div className="card-hover hero-feature">
                            <h3 style={{color: headingColor}}>Group</h3>
                            <h1>We organize a recurring group</h1>
                            <p style={{color: descColor}}>Our rates depend on number of group members</p>
                        </div>
                    </div>
                    <div>
                        <div className="card-hover hero-feature">
                            <h3 style={{color: headingColor}}>Online</h3>
                            <h1>We teach online via Skype </h1>
                            <p style={{color: descColor}}>$50 for 1 hour<br/>$75 for 2 hours</p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <CTA content="Contact Us to see what's best for you "/>
            </div>
        )
    }
}

export default Lessons